import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_ADMIN_PAYMENT_TERMS,
    UPDATE_ADMIN_PAYMENT_TERM,
    POST_ADMIN_PAYMENT_TERM
} from "./actionTypes"

import {
    getAdminPaymentTermsSuccess,
    getAdminPaymentTermsError,
    createAdminPaymentTermSuccess,
    createAdminPaymentTermError,
    updateAdminPaymentTermSuccess,
    updateAdminPaymentTermError
} from "./actions"

import {
    genericGetRequest, genericPostRequest, genericPutRequest
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminPaymentTerms(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_payment_terms`,
            action.payload?.queryParams,
            {
                Authorization: user.token,
            }
        )
        yield put(getAdminPaymentTermsSuccess(response))
    } catch (error) {
        yield put(getAdminPaymentTermsError(error))
    }
}

function* onCreateAdminPaymentTerm(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_payment_terms`;
        const payload = {
            body: JSON.stringify({...action.payload}),
            headers: {
              Authorization: user.token,
              'Content-Type': 'application/json',
            },
          }
        const response = yield call(genericPostRequest, URL, payload)
        yield put(createAdminPaymentTermSuccess(response))
    } catch (error) {
        yield put(createAdminPaymentTermError(error))
    }
}

function* onUpdateAdminPaymentTerm(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_payment_terms/${action?.payload?.admin_payment_term?.id}`;
        const payload = {
            body: JSON.stringify({...action.payload}),
            headers: {
              Authorization: user.token,
              'Content-Type': 'application/json',
            },
          }
        const response = yield call(genericPutRequest, URL, payload)
        yield put(updateAdminPaymentTermSuccess(response))
    } catch (error) {
        yield put(updateAdminPaymentTermError(error))
    }
}

function* AdminPaymentTermsSaga() {
    yield takeEvery(GET_ADMIN_PAYMENT_TERMS, onGetAdminPaymentTerms)
    yield takeEvery(POST_ADMIN_PAYMENT_TERM, onCreateAdminPaymentTerm)
    yield takeEvery(UPDATE_ADMIN_PAYMENT_TERM, onUpdateAdminPaymentTerm)
}

export default AdminPaymentTermsSaga

